const KEY_USER_INFO = 'user_info'

interface UserInfo {
  token: string
  fullname?: string
}

const userInfoJson = localStorage.getItem(KEY_USER_INFO)

const userInfo = userInfoJson == null ? undefined : JSON.parse(userInfoJson) as UserInfo
const authenticated = userInfo !== undefined

const store = {
  debug: true,
  state: {
    authenticated,
    userInfo: userInfo as UserInfo|undefined,
    expiredToken: false,
  },
  setUserInfo(value: UserInfo): void {
    this.state.userInfo = value
    localStorage.setItem(KEY_USER_INFO, JSON.stringify(value))
    this.state.authenticated = this.state.userInfo !== undefined
  },
  logout(): void {
    this.state.authenticated = false
    this.state.userInfo = undefined
    localStorage.removeItem(KEY_USER_INFO)
  },
  expireToken(): void {
    this.state.expiredToken = true
    this.state.userInfo = undefined
    localStorage.removeItem(KEY_USER_INFO)
    this.state.authenticated = this.state.userInfo !== undefined
  },
}

export default store
